enum BackgroundDialogFields {
	MODE = 'mode',
	TYPE = 'type',
	COLOR = 'color',
	OPACITY = 'opacity',
	RELATIVE = 'relative_to_page',
	SCALE = 'scale',
	POSITION = 'position',
	MARGIN_LEFT = 'margin_left',
	MARGIN_TOP = 'margin_top',
	ROTATION = 'rotation',
	IMAGE = 'image',
	VISIBILITY_PRINT = "visibility_print",
	VISIBILITY_SCREEN = "visibility_screen",
	PAGE_MODE = "page_mode",
	PAGE_FROM = "page_from",
	PAGE_TO = "page_to",
	PREVIEW = 'preview'
}

export default BackgroundDialogFields;